import React, { useEffect, useState } from "react";
import Header from "../Component/Header/Header";
import Footer from "../Component/Footer/Footer";

const PrivacyPolicy = () => {
  const [activeTab, setActiveTab] = useState("english");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tabStyle = {
    // padding: "8px 20px",
    // cursor: "pointer",
    // border: "1px solid #dee2e6",
    // background: "none",
    // borderRadius: "4px 4px 0 0",
    // marginRight: "4px",
    // fontWeight: 600,
  };

  const activeTabStyle = {
    // ...tabStyle,
    // backgroundColor: "#fff",
    // borderBottom: "1px solid #fff",
    // borderColor: "#dee2e6 #dee2e6 #fff",
    // color: "#495057",
  };

  const inactiveTabStyle = {
    ...tabStyle,
    backgroundColor: "#f8f9fa",
    color: "#6c757d",
  };

  return (
    <>
      <Header />
      <div className="rs-breadcrumbs img4">
        <div className="breadcrumbs-inner text-center">
          <h1 className="page-title">Privacy Policy</h1>
        </div>
      </div>

      <div className="rs-team-Single pt-80 pb-60 md-pt-80 md-pb-60">
        <div className="container">
          <div className="row">
            <section className="policy">
              <div className="terms-wrap ptb-100">
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12">
                      {/* Tab Buttons */}
                      <div
                        style={{
                          borderBottom: "1px solid #dee2e6",
                          marginBottom: "16px",
                        }}
                      >
                        <button
                          class="tab active"
                          style={
                            activeTab === "english"
                              ? activeTabStyle
                              : inactiveTabStyle
                          }
                          onClick={() => setActiveTab("english")}
                        >
                          English
                        </button>
                        <button
                          class="tab"
                          style={
                            activeTab === "hindi"
                              ? activeTabStyle
                              : inactiveTabStyle
                          }
                          onClick={() => setActiveTab("hindi")}
                        >
                          हिंदी
                        </button>
                      </div>

                      {/* ENGLISH TAB */}
                      {activeTab === "english" && (
                        <div className="container">
                          <br />
                          <div className="full-width-container">
                            <div className="content">
                              <div className="privacy">
                                <div className="privacy__main-content-container">
                                  <div className="privacy__main-content-container__main-content">
                                    <div id="privacy">
                                      <div className="privacy__main-content-container__main-content__text">
                                        <strong
                                          style={{
                                            fontSize: 20,
                                            position: "relative",
                                            bottom: 9,
                                          }}
                                        >
                                          Updated 16th February 2026
                                        </strong>
                                        <p>
                                          Pocket Vila Application is developed
                                          by AYYUN TELE SERVICES PRIVATE
                                          LIMITED, a company incorporated under
                                          the Companies Act, 1956 with 47 Sh 51
                                          Husaini Road Hindu Pura Kheda Near
                                          Ajeb Cold Storgae Sambhal 244302 Uttar
                                          Pradesh. This Policy describes how
                                          Pocket Vila and its
                                          Affiliates/Entities/Subsidiaries/Associates
                                          including but not limited to AYYUN
                                          TELE SERVICES PRIVATE LIMITED, Pocket
                                          Vila Insurance Broking Services
                                          Private Limited, AYYUN TELE SERVICES
                                          PRIVATE LIMITED (collectively "Pocket
                                          Vila, we, our, us" as the context may
                                          require) collect, store, use and
                                          otherwise process your Personal
                                          Information through Pocket Vila
                                          website, Pocket Vila Application,
                                          m-site, chatbot, notifications or any
                                          other medium used by Pocket Vila to
                                          provide its services to you
                                          (hereinafter referred to as the
                                          "Platform"). By downloading and using
                                          Pocket Vila, visiting the Pocket Vila
                                          website, providing your information or
                                          availing our product/services, you
                                          expressly agree to be bound by this
                                          Privacy Policy ("Policy") and the
                                          applicable service/product terms and
                                          conditions. We value the trust you
                                          place in us and respect your privacy,
                                          maintaining the highest standards for
                                          secure transactions and protection of
                                          your personal information.
                                        </p>
                                        <p>
                                          This Privacy Policy is published and
                                          shall be construed in accordance with
                                          the provisions of Indian laws and
                                          regulations including the Information
                                          Technology (Reasonable Security
                                          Practices and Procedures and Sensitive
                                          Personal Data or Information) Rules,
                                          2011 under the Information Technology
                                          Act, 2000, the Aadhaar Act, 2016 and
                                          its Amendments, including the Aadhaar
                                          Regulations; that require publishing
                                          of the privacy policy for collection,
                                          use, storage, transfer, disclosure of
                                          Personal Information. Please note, we
                                          do not offer any product/service under
                                          our Platform outside India. If you do
                                          not agree with this Privacy Policy,
                                          please do not use or access our
                                          Platform.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Information Collection
                                        </h6>
                                        <p>
                                          We may collect your Personal
                                          Information when you use our services
                                          or Platform or otherwise interact with
                                          us during the course of our
                                          relationship.
                                        </p>
                                        <p>
                                          Personal and Sensitive Personal
                                          Information collected includes but not
                                          limited to:
                                        </p>
                                        <ul className="lower-disc-list">
                                          <li>
                                            Personal details (e.g. name, contact
                                            details including, residential
                                            address, date of birth, user photo,
                                            documents such as identity card /
                                            passport details / Aadhaar details /
                                            PAN / Voter ID / driving license,
                                            and/or education details) provided
                                            by you to us to avail various
                                            products/services from us.
                                          </li>
                                          <li>
                                            PAN card number, KYC related
                                            information such as videos or other
                                            online/offline verification
                                            documents as mandated by relevant
                                            regulatory authorities, your
                                            business-related information
                                          </li>
                                          <li>
                                            Aadhaar information including
                                            Aadhaar number or Virtual ID for the
                                            purposes of e-KYC authentication
                                            with the Unique Identification
                                            Authority of India (UIDAI). Note
                                            that submission of Aadhaar
                                            information is not mandatory for
                                            e-KYC authentication, you can also
                                            use other types of information, such
                                            as your PAN or GST number
                                          </li>
                                          <li>
                                            Images of documents/ photos required
                                            to avail any of our
                                            products/services.
                                          </li>
                                          <li>
                                            OTP sent to you by your bank or
                                            Pocket Vila
                                          </li>
                                          <li>
                                            Balance, transaction history and
                                            value, bank account details, wallet
                                            balance, investment details and
                                            transactions, service or transaction
                                            related communication, part of your
                                            card details for smooth transaction
                                            using Pocket Vila or any of the
                                            services
                                          </li>
                                          <li>
                                            Your device details such as device
                                            identifier, internet bandwidth,
                                            mobile device model, browser
                                            plug-ins, and cookies or similar
                                            technologies that may identify your
                                            browser/Pocket Vila Application and
                                            plug-ins, and time spent, IP address
                                            and location
                                          </li>
                                        </ul>
                                        <p>
                                          Information may be collected at
                                          various stages of your usage of the
                                          Pocket Vila Platform such as:
                                        </p>
                                        <ul className="lower-disc-list">
                                          <li>
                                            Access to your mobile camera device
                                            for the functioning of many in-app
                                            functionalities for recording video
                                            including, but not limited to video
                                            KYC process and scan &amp; pay etc.
                                          </li>
                                          <li>
                                            User Self Picture selfie (Photo)
                                            image is Required For the purpose of
                                            KYC and to Display in Dashboard.
                                            This Picture/Image Can Be share with
                                            Government Authorities and KYC
                                            Service Provider just like NSDL,
                                            UTI, UIDIA.
                                          </li>
                                          <li>Visiting Pocket Vila Platform</li>
                                          <li>
                                            Registering on Pocket Vila Platform
                                            as an "user" or "merchant" or any
                                            other relationship that may be
                                            governed by terms and conditions
                                            listed on Pocket Vila Platform
                                          </li>
                                          <li>
                                            Transacting or attempting to
                                            transact on Pocket Vila Platform
                                          </li>
                                          <li>
                                            Accessing links, e-mails, chat
                                            conversations, feedbacks,
                                            notifications sent or owned by
                                            Pocket Vila Platform
                                          </li>
                                          <li>
                                            Otherwise dealing with any of the
                                            Pocket Vila
                                            Affiliates/Entities/Subsidiaries/Associates
                                          </li>
                                          <li>
                                            While applying for career
                                            opportunities with Pocket Vila
                                          </li>
                                        </ul>
                                        <p>
                                          We and our service providers or
                                          business partners may also collect
                                          your Personal Information from third
                                          parties or information made publicly
                                          available including but not limited
                                          to:
                                        </p>
                                        <ul className="lower-disc-list">
                                          <li>
                                            Financial history and other
                                            information for the purpose of
                                            verifying and authenticating an
                                            investment transaction request
                                          </li>
                                          <li>
                                            Vehicle-related information when you
                                            opt for vehicle insurance
                                          </li>
                                          <li>
                                            Your resume, your past employment
                                            and educational qualification for
                                            background checks and verifications
                                          </li>
                                          <li>
                                            Your demographic and photo
                                            information including but not
                                            limited to Aadhaar number, address,
                                            gender, and date of birth as a
                                            response received from UIDAI upon
                                            successful Aadhaar e-KYC
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Purpose and Use of Information
                                        </h6>
                                        <p>
                                          Pocket Vila may process your Personal
                                          Information for the following
                                          purposes:
                                        </p>
                                        <ul className="lower-disc-list">
                                          <li>
                                            Creation of your account and
                                            verification of your identity and
                                            access privileges
                                          </li>
                                          <li>
                                            Provide you access to the products
                                            and services being offered by us,
                                            merchants, affiliates, subsidiaries,
                                            associates, or business partners
                                          </li>
                                          <li>
                                            To conduct the KYC compliance
                                            process as a mandatory prerequisite
                                            as per the requirements of various
                                            regulatory bodies
                                          </li>
                                          <li>
                                            To validate, process and/or share
                                            your KYC information, nominee
                                            details with other intermediaries,
                                            Regulated Entities (REs) or AMCs or
                                            financial institutions
                                          </li>
                                          <li>
                                            To process payments on your behalf
                                            and on your instructions;
                                            communicate with you for your
                                            queries, transactions, and/or any
                                            other regulatory requirement
                                          </li>
                                          <li>
                                            To authenticate a transaction
                                            request; validate a standing
                                            instruction for a Systematic
                                            Investment Plan or confirm a payment
                                            made via the services
                                          </li>
                                          <li>
                                            Enhancing your user experience by
                                            analysing user behaviour on an
                                            aggregated basis
                                          </li>
                                          <li>
                                            To monitor and review
                                            products/services from time to time;
                                            customize the services to make your
                                            experience safer and easier, and
                                            conducting audits
                                          </li>
                                          <li>
                                            To allow third parties to contact
                                            you for products and services
                                            availed/requested by you on Pocket
                                            Vila Platform
                                          </li>
                                          <li>
                                            To carry credit checks, screenings
                                            or due diligence checks as lawfully
                                            required; detect and protect us
                                            against error, fraud, money
                                            laundering and other criminal
                                            activity
                                          </li>
                                          <li>
                                            To inform you about online and
                                            offline offers, products, services,
                                            and updates
                                          </li>
                                          <li>
                                            To resolve disputes; troubleshoot
                                            problems; technical support and
                                            fixing bugs; help promote a safe
                                            service
                                          </li>
                                          <li>
                                            To identify security breaches and
                                            attacks; investigating, preventing,
                                            and taking action on illegal or
                                            suspected fraud or money laundering
                                            activities
                                          </li>
                                          <li>To meet legal obligations</li>
                                        </ul>
                                        <p>
                                          Location Access: We are Collecting
                                          Information for Realtime location (GEO
                                          Location) Which is Required For
                                          Banking (Rural Banking-Banking BC)
                                          Transactions such as Money Transfer
                                          Service, BBPS and AEPS Service which
                                          is governed By NPCI (National Payment
                                          Corporation of India).
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Cookies or Similar Technologies
                                        </h6>
                                        <p>
                                          We use data collection devices such as
                                          "cookies" or similar technologies on
                                          certain pages of the Platform to help
                                          analyse our web page flow, measure
                                          promotional effectiveness, and promote
                                          trust and safety. "Cookies" are small
                                          files placed on your device
                                          hard-drive/storage that assist us in
                                          providing our services. Cookies do not
                                          contain any of your Personal
                                          Information. Most cookies are "session
                                          cookies," meaning that they are
                                          automatically deleted from your device
                                          hard-drive/storage at the end of a
                                          session. We do not control the use of
                                          cookies by third parties.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Information Sharing and Disclosures
                                        </h6>
                                        <p>
                                          Your Personal Information is shared as
                                          allowed under applicable laws, after
                                          following due diligence and in line
                                          with the purposes set out in this
                                          Policy.
                                        </p>
                                        <p>
                                          Personal Information will be shared,
                                          as applicable, on need-to-know basis,
                                          for the following purposes:
                                        </p>
                                        <ul className="lower-disc-list">
                                          <li>
                                            For enabling the provision of the
                                            products/services availed by you and
                                            facilitating the services between
                                            you and the service provider
                                          </li>
                                          <li>
                                            For the Aadhaar authentication
                                            process by submitting Aadhaar
                                            information to Central Identities
                                            Data Repository (CIDR) and National
                                            Securities Depository Limited (NSDL)
                                          </li>
                                          <li>
                                            For complying with applicable laws
                                            as well as meeting the Know Your
                                            Customer (KYC) requirements as
                                            mandated by various regulatory
                                            bodies
                                          </li>
                                          <li>
                                            For completing a payment transaction
                                            initiated by you on a merchant site
                                          </li>
                                          <li>
                                            For the purpose of processing your
                                            financial product subscription
                                            requests
                                          </li>
                                          <li>
                                            If it is required by financial
                                            institutions to verify, mitigate, or
                                            prevent fraud or to manage risk or
                                            recover funds
                                          </li>
                                          <li>
                                            For services related to
                                            communication, marketing, data and
                                            information storage, transmission,
                                            security, analytics, fraud
                                            detection, risk assessment and
                                            research
                                          </li>
                                          <li>
                                            To enforce our Terms or Privacy
                                            Policy; respond to claims; or
                                            protect the rights, property or
                                            personal safety of our users
                                          </li>
                                          <li>
                                            If required to do so by law or in
                                            good faith to respond to subpoenas,
                                            court orders, or other legal process
                                          </li>
                                          <li>
                                            If requested by government
                                            authorities for government
                                            initiatives and benefits
                                          </li>
                                          <li>
                                            For grievance redressal and
                                            resolution of disputes
                                          </li>
                                          <li>
                                            With the internal investigation
                                            department within Pocket Vila or
                                            agencies appointed by Pocket Vila
                                            for investigation purposes
                                          </li>
                                          <li>
                                            Should we plan to merge with, or be
                                            acquired by any business entity, or
                                            re-organization, amalgamation,
                                            restructuring of our business
                                          </li>
                                        </ul>
                                        <p>
                                          We do not accept any responsibility or
                                          liability for usage of your Personal
                                          Information by these third parties or
                                          their policies.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Storage and Retention
                                        </h6>
                                        <p>
                                          To the extent applicable, we store
                                          Personal Information within India and
                                          retain it in accordance with
                                          applicable laws and for a period no
                                          longer than it is required for the
                                          purpose for which it was collected.
                                        </p>
                                        <p>
                                          Once the Personal Information has
                                          reached its retention period, it shall
                                          be deleted in compliance with
                                          applicable laws.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Reasonable Security Practices
                                        </h6>
                                        <p>
                                          Pocket Vila has deployed technical and
                                          physical security measures to
                                          safeguard user's Personal Information
                                          and Sensitive Personal Information.
                                          The database is stored on servers
                                          secured behind a firewall; access to
                                          the servers is password-protected and
                                          is strictly limited.
                                        </p>
                                        <p>
                                          Further, you are responsible for
                                          maintaining the confidentiality and
                                          security of your login id and
                                          password. Please do not share your
                                          Pocket Vila login, password, and OTP
                                          details with anybody.
                                        </p>
                                        <p>
                                          We have provided multiple levels of
                                          security to safeguard the Pocket Vila
                                          Application by login/logout option and
                                          Pocket Vila Application lock feature
                                          ("Enable Screen Lock") that can be
                                          enabled by you.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Third-Party Products, Services, or
                                          Websites
                                        </h6>
                                        <p>
                                          When you are availing products and
                                          services of service providers on
                                          Pocket Vila Platform, Personal
                                          Information may be collected by
                                          respective service providers and such
                                          Personal Information shall be governed
                                          by their privacy policy.
                                        </p>
                                        <p>
                                          Our services may include links to
                                          other websites or applications when
                                          you visit our Platform. Such websites
                                          or applications are governed by their
                                          respective privacy policies, which are
                                          beyond our control. We do not accept
                                          any responsibility or liability for
                                          usage of your Personal Information by
                                          these third parties or their policies.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Your Consent
                                        </h6>
                                        <p>
                                          We process your Personal Information
                                          with consent. By using the Pocket Vila
                                          Platform or services and/or by
                                          providing your Personal Information,
                                          you consent to the processing of your
                                          Personal Information by Pocket Vila in
                                          accordance with this Privacy Policy.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Choice/Opt-out
                                        </h6>
                                        <p>
                                          We provide all users with the
                                          opportunity to opt-out of receiving
                                          any of our services or non-essential
                                          (promotional, marketing-related)
                                          communications from us, after setting
                                          up an account. Please click on the
                                          unsubscribe button on the emailers.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Personal Information
                                          Access/Rectification and Consent
                                        </h6>
                                        <p>
                                          You can access and review your
                                          Personal Information shared by you by
                                          placing a request with us. In
                                          addition, you may at any time revoke
                                          consent given to us to store your
                                          e-KYC information.
                                        </p>
                                        <p>
                                          In case you wish to delete your
                                          account or Personal Information,
                                          please use the 'Help' section of the
                                          Pocket Vila Platform. However,
                                          retention of your Personal Information
                                          will be subject to applicable laws.
                                        </p>
                                        <p>
                                          For the above requests, Pocket Vila
                                          may need to request specific
                                          information from you to confirm your
                                          identity and ensure authentication.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Children Information
                                        </h6>
                                        <p>
                                          We do not knowingly solicit or collect
                                          Personal Information from children
                                          under the age of 18 and use of our
                                          Platform is available only to persons
                                          who can form a legally binding
                                          contract under the Indian Contract
                                          Act, 1872.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Changes to Policy
                                        </h6>
                                        <p>
                                          Since our business changes constantly,
                                          so will our policies. We reserve the
                                          right, at our sole discretion, to
                                          change, modify, add, or remove
                                          portions of this Privacy Policy at any
                                          time without any prior written notice
                                          to you.
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          Contact Us
                                        </h6>
                                        <p>
                                          In case you have any questions,
                                          concerns, or complaints regarding the
                                          processing of your Personal
                                          Information or this Privacy Policy you
                                          may write to Pocket Vila's Privacy
                                          Officer using this link{" "}
                                          <a
                                            href="https://b2cadmin.fusioncodes.in/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            support@fusioncodes.in
                                          </a>
                                          . We are committed to answer your
                                          questions within the reasonable time
                                          limit.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* HINDI TAB */}
                      {activeTab === "hindi" && (
                        <div className="container">
                          <br />
                          <div className="full-width-container">
                            <div className="content">
                              <div className="privacy">
                                <div className="privacy__main-content-container">
                                  <div className="privacy__main-content-container__main-content">
                                    <div id="privacy-hindi">
                                      <div className="privacy__main-content-container__main-content__text">
                                        <strong
                                          style={{
                                            fontSize: 20,
                                            position: "relative",
                                            bottom: 9,
                                          }}
                                        >
                                          16 फरवरी 2026 को अपडेट किया गया
                                        </strong>
                                        <p>
                                          Pocket Vila ऐप्लिकेशन को Pocket Vila
                                          प्राइवेट लिमिटेड ने तैयार किया है। इस
                                          कंपनी का गठन कंपनी अधिनियम, 1956 के
                                          तहत किया गया है। इसके रजिस्टर्ड ऑफ़िस
                                          का पता है - 47 एसएच 51 हुसैनी रोड
                                          हिंदू पुरा खेड़ा निकट अजेब कोल्ड
                                          स्टोरेज संभल 244302 उत्तर प्रदेश।
                                        </p>
                                        <p>
                                          कृपया ध्यान दें, हम अपने प्लेटफ़ार्म
                                          के तहत भारत से बाहर कोई प्रॉडक्ट/सेवा
                                          ऑफ़र नहीं करते हैं। अगर आप इस
                                          प्राइवेसी पॉलिसी से सहमत नहीं हैं, तो
                                          कृपया हमारे प्लेटफ़ार्म का न तो
                                          इस्तेमाल करें और न ही उसे एक्सेस करें।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          जानकारी इकट्ठा करना
                                        </h6>
                                        <p>
                                          हम उस समय आपकी निजी जानकारी इकट्ठा कर
                                          सकते हैं, जब आप हमारी सेवाओं या
                                          प्लेटफ़ार्म का इस्तेमाल करेंगे।
                                        </p>
                                        <p>
                                          इकट्ठा की जाने वाली निजी और संवेदनशील
                                          निजी जानकारी में नीचे दी गई चीज़ों के
                                          अलावा, और भी चीज़ें शामिल हो सकती हैं:
                                        </p>
                                        <ul className="lower-disc-list">
                                          <li>
                                            नाम, उम्र, लिंग, फ़ोटो, पता, फ़ोन
                                            नंबर, ईमेल आईडी, आपके संपर्क और
                                            नॉमिनी की जानकारी
                                          </li>
                                          <li>
                                            PAN कार्ड नंबर, आपके कारोबार से
                                            जुड़ी जानकारी, KYC से जुड़ी जानकारी
                                          </li>
                                          <li>
                                            भारतीय विशिष्ट पहचान प्राधिकरण
                                            (UIDAI) के साथ ई-KYC प्रमाणीकरण के
                                            प्रयोजनों के लिए आधार नंबर या
                                            वर्चुअल आईडी सहित आधार जानकारी।
                                          </li>
                                          <li>
                                            वह OTP जो आपके बैंक या Pocket Vila
                                            की ओर से भेजा गया हो
                                          </li>
                                          <li>
                                            बैलेंस, लेन-देन की जानकारी और
                                            वैल्यू, बैंक खाते की जानकारी, वॉलेट
                                            बैलेंस
                                          </li>
                                          <li>
                                            आपके डिवाइस की जानकारी, जैसे कि
                                            डिवाइस की पहचान वाला कोड, इंटरनेट
                                            बैंडविथ, मोबाइल डिवाइस का मॉडल
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          सूचना इकट्ठा करने का मकसद और उसका
                                          इस्तेमाल
                                        </h6>
                                        <p>
                                          Pocket Vila नीचे बताए गए मकसद के लिए
                                          आपकी निजी सूचना का इस्तेमाल कर सकता
                                          है:
                                        </p>
                                        <ul className="lower-disc-list">
                                          <li>
                                            आपका खाता बनाने और आपकी पहचान की
                                            पुष्टि करने के लिए
                                          </li>
                                          <li>
                                            आपको उन प्रॉडक्ट और सेवाओं का एक्सेस
                                            देने के लिए जो हम ऑफ़र करते हैं
                                          </li>
                                          <li>
                                            KYC के अनुपालन की प्रक्रिया पूरी
                                            करने के लिए
                                          </li>
                                          <li>
                                            लेन-देन के किसी अनुरोध को प्रमाणित
                                            करने के लिए
                                          </li>
                                          <li>
                                            विवादों और समस्याओं का हल करने के
                                            लिए
                                          </li>
                                          <li>
                                            कानूनी जवाबदेही का पालन करने के लिए
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          कुकीज़ या इसी तरह की तकनीक
                                        </h6>
                                        <p>
                                          हम प्लेटफ़ार्म के कुछ पेज पर डेटा
                                          इकट्ठा करने वाली डिवाइसों, जैसे कि
                                          "कुकीज़" या इसी प्रकार की तकनीकों का
                                          इस्तेमाल करते हैं। "कुकीज़" ऐसी छोटी
                                          फ़ाइलें होती हैं जिन्हें आपकी डिवाइस
                                          की हार्ड ड्राइव/स्टोरेज में रखा जाता
                                          है। कुकीज़ में आपकी कोई भी निजी
                                          जानकारी नहीं होती है।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          जानकारी शेयर करना और उसे ज़ाहिर करना
                                        </h6>
                                        <p>
                                          आपकी व्यक्तिगत जानकारी को उचित सावधानी
                                          का पालन करने के बाद और इस नीति में
                                          निर्धारित उद्देश्यों के अनुरूप लागू
                                          कानूनों के तहत अनुमति के अनुसार साझा
                                          किया जाता है।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          जानकारी को सेव करना और उसे बनाए रखना
                                        </h6>
                                        <p>
                                          लागू होने की सीमा तक, हम निजी जानकारी
                                          को भारत के अंदर और लागू होने वाले
                                          कानून के हिसाब से सेव करके रखते हैं।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          सुरक्षा से जुड़े उचित तरीके
                                        </h6>
                                        <p>
                                          Pocket Vila ने यूज़र की निजी जानकारी
                                          और संवेदनशील जानकारी की सुरक्षा के लिए
                                          तकनीकी और सामान्य सुरक्षा उपाय किए
                                          हैं।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          थर्ड पार्टी के प्रॉडक्ट, सेवाएं या
                                          वेबसाइट
                                        </h6>
                                        <p>
                                          जब आप Pocket Vila प्लेटफ़ार्म पर मौजूद
                                          सर्विस प्रोवाइडर के प्रॉडक्ट और सेवाओं
                                          का इस्तेमाल करते हैं, तो निजी जानकारी
                                          उन्हीं सर्विस प्रोवाइडर के ज़रिए
                                          इकट्ठा की जा सकती है।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          आपकी सहमति
                                        </h6>
                                        <p>
                                          हम आपकी सहमति से आपकी निजी जानकारी को
                                          प्रोसेस करते हैं। Pocket Vila
                                          प्लेटफ़ार्म या सेवाओं का इस्तेमाल करके
                                          और/या अपनी निजी जानकारी उपलब्ध कराकर,
                                          आप इस बात की सहमति देते हैं।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          विकल्प/ऑप्ट-आउट
                                        </h6>
                                        <p>
                                          खाता सेटअप करने के बाद, हम सभी
                                          उपयोगकर्ताओं को इस विकल्प को चुनने का
                                          मौका देते हैं कि वह हमारी सेवाओं को
                                          इस्तेमाल नहीं करना चाहते हैं।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          निजी जानकारी को एक्सेस करना/ सुधार
                                          करना और सहमति
                                        </h6>
                                        <p>
                                          आप जो हमारे साथ अपनी निजी जानकारी शेयर
                                          करते हैं उसे एक्सेस कर सकते हैं और देख
                                          सकते हैं।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          बच्चों से जुड़ी जानकारी
                                        </h6>
                                        <p>
                                          हम जानबूझकर न तो 18 साल से कम उम्र
                                          बच्चों की निजी जानकारी मांगते हैं और न
                                          ही उसे इकट्ठा करते हैं।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          पॉलिसी में होने वाले बदलाव
                                        </h6>
                                        <p>
                                          चूंकि हमारे कारोबार में लगातार बदलाव
                                          होता रहता है, इसी तरह हमारी पॉलिसी में
                                          भी बदलाव होता रहता है।
                                        </p>
                                      </div>

                                      <div className="privacy__main-content-container__main-content__text">
                                        <h6 style={{ fontWeight: "bold" }}>
                                          हमसे संपर्क करें
                                        </h6>
                                        <p>
                                          अगर आपके पास कोई सवाल है, तो आप Pocket
                                          Vila गोपनीयता अधिकारी को{" "}
                                          <a
                                            href="https://b2cadmin.fusioncodes.in/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            support@fusioncodes.in
                                          </a>{" "}
                                          पर लिख सकते हैं।
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
